<div class="context-menu" (click)="open($event, true)">
	<flx-icon class="context-menu-icon" [type]="icon" [size]="iconSize"></flx-icon>
	<ng-template cdkPortal #portal="cdkPortal"> <ng-content #menuItems></ng-content> </ng-template>
</div>
